import { BlockSelectField } from '@common/components/FormElements/BlockSelectField';
import moment from 'moment';
import { Controller, FieldPath, useFormContext } from 'react-hook-form';
import { RoomExtraOption, RoomExtraOptionPerDateTimeType } from 'shared-types/Room';
import { RoomRateFormValues } from '../../../../RoomRateForm.schema';

const optionsForPerDateTime = (options: RoomExtraOptionPerDateTimeType[]) =>
  options.map((option, index) => ({
    label: `${moment(option.startDate).format('MMM DD')} - ${option?.startTime?.substr(0, 5)}`,
    value: index,
  }));

type SelectOption = { label: string; value: number };

export const PerDateTime = ({ id, options }: { id: number; options: RoomExtraOption[] }) => {
  const { control } = useFormContext<RoomRateFormValues>();
  const opts = optionsForPerDateTime(options as RoomExtraOptionPerDateTimeType[]);

  return (
    <Controller
      control={control}
      name={`extras.${id}.option` as FieldPath<RoomRateFormValues>}
      render={({ field: { value, onChange } }) => (
        <BlockSelectField
          options={opts}
          value={opts.find((o) => o.value === value) ?? null}
          onChange={(selected: SelectOption) => onChange(selected?.value ?? null)}
        />
      )}
    />
  );
};
